import Vue from 'vue';
import planTable from './plan-table.js';


function Subscription(config) {
	if (!(this instanceof Subscription)) {
		return new Subscription(config);
	}
	if (config) {
		Vue.util.extend(this, config);
	}
}

Subscription.prototype = {
	constructor: Subscription,

	accountId: '',
	coupons: null,
	created: null,
	id: '',
	plan: null,
	prepaidCouponId: null,

	productName: '',
	action: '',
	path: '',
	children: [],
	type: undefined,

	trialExpiry: null,
	currentPeriodEnd: null,

	attachAddOns: function (allAddOns) {
		let sub = this;
		this.plan.addOns = allAddOns.filter(addOn => addOn.checked);
		this.plan.allAddOns = allAddOns;
		this.plan.mappedAddOns = mapAddOns(deepCopy(allAddOns), sub);
	},
};

function deepCopy(obj) {
	return JSON.parse(JSON.stringify(obj));
}

function selectIncludedPackages(addOnWithPackages, addOns) {
	addOns.filter(addOn=>{
		return addOnWithPackages.includedPackages.includes(addOn.name);
	}).map(item=>{
		item.bundled = addOnWithPackages.checked ? {package: addOnWithPackages.shortName} : false;
		return item;
	});
}

function getDisplayCode(prepaidCouponId) {
	// create a display code for viewing
	return prepaidCouponId.split('_')[1];
}

function mapAddOns(addOns, currentSub) {
	const selectedAddOns = currentSub.plan.currentAddOns;
	const list = addOns.map(addOn => {
		const addOnList = selectedAddOns.list || selectedAddOns;
		addOn.checked = addOnList.includes(addOn.name);
		addOn.isCurrent = addOn.checked;
		const hasTrial = addOn.hasTrial && !addOn.isCurrent;
		let isTrial;
		const trialAddOn = selectedAddOns.trialAddOns && selectedAddOns.trialAddOns.find(trialItem => addOn.name === trialItem.name);
		isTrial = trialAddOn;
		addOn.expiry = trialAddOn && trialAddOn.expiry;
		const isPrepaid = currentSub.type === 'Prepaid';
		addOn.isTrial = isTrial;
		addOn.hasTrial = hasTrial;
		addOn.isPrepaid = isPrepaid;
		addOn.amountDue = isPrepaid || isTrial || hasTrial ? 0 : addOn.amount;
		if (addOn.hasIncludedPackages) {
			selectIncludedPackages(addOn, addOns);
		}
		return addOn;
	});

	return list;
}

function addOnReducer(currentAddOns, current, index, array) {
	let currentAddOnKey = (current.type ? current.type.toLowerCase() : 'paid') + 'AddOns';
	const currentPlanAddOns = current.plan.addOns || current.plan.currentAddOns;
	//create keys for each addOn type
	currentAddOns[currentAddOnKey] = currentAddOns[currentAddOnKey].concat(currentPlanAddOns.map(addOn=> { return { name: addOn, expiry: current.currentPeriodEnd}; }));
	//keep list of all addons
	currentAddOns.list = currentAddOns.list.concat(currentPlanAddOns);
	return currentAddOns;
}


function planFromDTO(dto){
	if (dto === null || dto === undefined) {
		return null;
	}

	let plan = dto.plan || {};
	const intervalId = plan.id + '_' + plan.interval;

	// combine addons from two different scope subscriptions
	let currentAddOns = dto.children && dto.children.reduce(addOnReducer, { paidAddOns: [], trialAddOns: [], prepaidAddOns: [], list:[] }) || dto.plan.addOns;

	return {
		id: plan.id,
		isCurrent: true,
		currentAddOns: currentAddOns,
		currentAddOnsDisplayText: currentAddOns ? (currentAddOns.list || currentAddOns || []).join(', ') : '',
		allAddOns: plan.allAddOns || [], // full list of add-ons
		interval: plan.interval,
		name: planTable[plan.id].name,
		description: planTable[plan.id].description,
		intervalId: intervalId,
		discounted: plan.coupons && plan.coupons.length > 0,
		hasQuantity: planTable[plan.id].hasQuantity,
		isInternalFreePlan: dto.plan.id === 'pln_scope_app_base' && dto.plan.interval === 'free'
	};
}

function isFreePlan(plan) {
	return plan.id === 'pln_scope_app_base' && plan.addOns.length === 0 || plan.id.includes('free');
}

function getType(sub) {
	return (sub.type === 'Prepaid' || sub.type === 'Trial') ? sub.type : isFreePlan(sub.plan) ? 'Free' : 'Credit Card';
}

Subscription.fromDTO = function (dto, product) {
	if (dto === null || dto === undefined) {
		return null;
	}

	const trialExpiresOn = getType(dto) === 'Trial' ? dto.currentPeriodEnd : null;

	return new Subscription({
		accountId: dto.id,
		coupons: dto.coupons,
		created: dto.created,
		id: dto.id,
		plan: planFromDTO(dto),
		type: getType(dto),
		prepaidCouponId: dto.prepaidCouponId,
		prepaidDisplayCode: dto.prepaidCouponId ? getDisplayCode(dto.prepaidCouponId) : null,
		productName: 'IoT',
		action: [],
		path: 'iot',
		quantity: dto.quantity,
		trialExpiry: trialExpiresOn || dto.trialExpiry,
		expiry: dto.currentPeriodEnd
	});
};

Subscription.scopeFromDTO = function (dto, product) {
	if (dto === null || dto === undefined) {
		return null;
	}

	let plan = planFromDTO(dto);

	return new Subscription({
		children: dto.children,
		accountId: dto.id,
		coupons: dto.coupons,
		created: dto.created,
		id: dto.id,
		plan: planFromDTO(dto),
		type: getType(dto),
		prepaidCouponId: dto.prepaidCouponId,
		prepaidDisplayCode: dto.prepaidCouponId ? getDisplayCode(dto.prepaidCouponId) : null,
		productName: 'TekScope',
		action: [],
		path: 'scope',
		quantity: dto.quantity,
		trialExpiry: dto.trialExpiresOn || dto.trialExpiry,
		expiry: dto.currentPeriodEnd || dto.expiry
	});
};

Subscription.driveFromDTO = function (dto, product) {
	if (dto === null || dto === undefined) {
		return null;
	}

	let plan = planFromDTO(dto);

	return new Subscription({
		children: dto.children,
		accountId: dto.id,
		coupons: dto.coupons,
		created: dto.created,
		id: dto.id,
		plan: planFromDTO(dto),
		isTrial: dto.type === 'Trial',
		isPrepaid: dto.type === 'Prepaid',
		type: getType(dto),
		prepaidCouponId: dto.prepaidCouponId,
		prepaidDisplayCode: dto.prepaidCouponId ? getDisplayCode(dto.prepaidCouponId) : null,
		productName: 'TekDrive',
		action: [],
		path: 'drive',
		quantity: dto.quantity,
		trialExpiry: dto.trialExpiresOn || dto.trialExpiry,
		expiry: dto.currentPeriodEnd || dto.expiry
	});
};

export default Subscription;



// WEBPACK FOOTER //
// ./src/store/models/subscription.js